interface TableSkeletonProps {
  rows?: number;
}

export default function TableSkeleton({ rows = 5 }: TableSkeletonProps) {
  return (
    <div className="animate-pulse">
      {Array.from({ length: rows }).map((_, row) => (
        <div
          key={row}
          className="flex items-center gap-4 border-b border-background-200/60 px-5 py-4 last:border-0"
        >
          <div className="h-11 w-11 shrink-0 rounded-lg bg-background-200"></div>
          <div className="flex-1">
            <div className="h-3.5 w-3/4 rounded-full bg-background-200"></div>
            <div className="mt-2 h-3 w-1/2 rounded-full bg-background-100"></div>
          </div>
          <div className="hidden h-3.5 w-24 rounded-full bg-background-200 sm:block"></div>
          <div className="hidden h-3.5 w-16 rounded-full bg-background-200 md:block"></div>
          <div className="h-8 w-20 shrink-0 rounded-md bg-background-200"></div>
        </div>
      ))}
    </div>
  );
}